import React from "react";
import { Link } from "react-router-dom";
import "./WigCard.css";

export default function WigCard({ wig }) {
  return (
    <Link to={`/wig/${wig._id}`} className="wig-card">
      <div className="wig-card-image">
        <img src={wig.images[0]} alt={wig.name} />
        <span className="wig-badge">{wig.category}</span>
      </div>
      <div className="wig-card-content">
        <h3>{wig.name}</h3>
        <p className="wig-description">{wig.description.substring(0, 50)}...</p>
        <p className="wig-price">₹{wig.price.toLocaleString()}</p>
      </div>
    </Link>
  );
}
